import React, { useState } from 'react';

import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import LocalInput from '../components/localInput/';

import MenuItem from '@material-ui/core/MenuItem';

const useDropdown = (label, defaultState, options) => {
  const [state, updateState] = useState(defaultState);
  const id = `use-dropdown-${label.replace(' ', '').toLowerCase()}`;

  const Dropdown = () => (
    <>
      <InputLabel shrink style={{}}>
        {label}
      </InputLabel>
      <Select
        id={id}
        value={state}
        onChange={e => updateState(e.target.value)}
        input={<LocalInput id={id} />}
        disabled={!options.length}
        fullWidth
      >
        <MenuItem value="">
          <em>Vacío</em>
        </MenuItem>
        {options.map(item => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
  return [state, Dropdown, updateState];
};

export default useDropdown;
